import { canAccessProtectedNetwork } from '../authStatus'
import { isAuthExpiredError } from '../authErrors'
import { getAbsoluteEndpoint, getSubmissionsPath } from '../apiRouting'
import { buildProtectedAuthHeaders, fetchWithTimeout, throwIfAuthRejected } from './client'

export async function checkApiAvailability(): Promise<boolean> {
  if (!canAccessProtectedNetwork()) {
    return false
  }

  try {
    const headers = await buildProtectedAuthHeaders('check api availability', {
      'Content-Type': 'application/json',
    })
    const submissionsBase = getAbsoluteEndpoint('submissionsRead', getSubmissionsPath)
    const response = await fetchWithTimeout(
      `${submissionsBase}?limit=1`,
      { method: 'GET', headers },
      8_000,
    )

    // Only 401 means re-authenticate (propagated to the caller). Any other
    // status — including a 403 "forbidden" — just means the API isn't usable
    // right now, so report unavailable without signing the user out.
    throwIfAuthRejected(response, 'check api availability')
    return response.ok
  } catch (error) {
    if (isAuthExpiredError(error)) {
      throw error
    }
    return false
  }
}
